import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import { string, bool, object, array } from "prop-types";

import Navbar from "./Navbar";
import HeaderTopContent from "./HeaderTopContent";
import SecondaryHeaderTopContent from "./SecondaryHeaderTopContent";
import SectionHeaderTopContent from "./SectionHeaderTopContent";
import SecondarySectionHeaderTopContent from "./SecondarySectionHeaderTopContent";
import SecondaryStoryHeaderTopContent from "./SecondaryStoryHeaderTopContent";
import StoryHeaderTopContent from "./StoryHeaderTopContent";

import { getMultiDomainMenuData } from "../utils/utils";
import DefaultHeader from "./DefaultHeader";

import "./header.m.css";

const BigHeaderComponent = ({ headerProps, menuItemsObject, domainConfig, page }) => {
  return (
    <div styleName="container">
      {page === "home" ? (
        <>
          {" "}
          <HeaderTopContent {...headerProps} />
          <Navbar
            menu={
              menuItemsObject &&
              menuItemsObject.homePageMenuItems &&
              menuItemsObject.homePageMenuItems.children.length > 0
                ? menuItemsObject.homePageMenuItems.children.slice(0, 12)
                : null
            }
            domainInfo={domainConfig}
          />
        </>
      ) : (
        <SectionHeaderTopContent
          {...headerProps}
          navbarMenu={
            menuItemsObject &&
            menuItemsObject.sectionPageMenuItems &&
            menuItemsObject.sectionPageMenuItems.children.length > 0
              ? menuItemsObject.sectionPageMenuItems.children
              : null
          }
        />
      )}
    </div>
  );
};

const StickyComponent = ({ domainConfig, headerProps, menuItemsObject, page }) => {
  return (
    <div className={` sticky-header ${domainConfig ? domainConfig.className : ""}`} styleName="sticky-header">
      {page === "home" ? (
        <SecondaryHeaderTopContent
          {...headerProps}
          navbarMenu={
            menuItemsObject &&
            menuItemsObject.homePageMenuItems &&
            menuItemsObject.homePageMenuItems.children.length > 0
              ? menuItemsObject.homePageMenuItems.children.slice(0, 12)
              : null
          }
        />
      ) : (
        <SecondarySectionHeaderTopContent
          {...headerProps}
          navbarMenu={
            menuItemsObject &&
            menuItemsObject.sectionPageMenuItems &&
            menuItemsObject.sectionPageMenuItems.children.length > 0
              ? menuItemsObject.sectionPageMenuItems.children
              : null
          }
        />
      )}
    </div>
  );
};

const HeaderBase = props => {
  const {
    domainSlug,
    protichintaMenuItems,
    trustMenuItems,
    kishoraloMenuItems,
    bondhushavaMenuItems,
    bigganChintaMenuItems,
    prothomaloMenuItems,
    nagorikMenuItems,
    isVideoStory = false,
    publisherAttributes,
    stickyHeader,
    isDesktop
  } = props;

  const getMultiDomainMenuItems = getMultiDomainMenuData(
    domainSlug,
    protichintaMenuItems,
    trustMenuItems,
    kishoraloMenuItems,
    bondhushavaMenuItems,
    bigganChintaMenuItems,
    prothomaloMenuItems,
    nagorikMenuItems
  );

  const getMenuItems = props.domainSlug ? getMultiDomainMenuItems : prothomaloMenuItems;
  const menuItemsObject =
    getMenuItems.length > 0
      ? {
          homePageMenuItems: getMenuItems.find(item => item.title === "home"),
          hamburgerMenuItems: getMenuItems.find(item => item.title === "hamburger"),
          sectionPageMenuItems: getMenuItems.find(item => item.title === "sections")
        }
      : null;

  const headerProps = {
    domainInfo: props.domainConfig,
    hamburgerMenu:
      menuItemsObject && menuItemsObject.hamburgerMenuItems && menuItemsObject.homePageMenuItems.children.length > 0
        ? menuItemsObject.hamburgerMenuItems.children
        : []
  };

  const homeSectionHeaderComponent = page => {
    return (
      <React.Fragment>
        {isDesktop ? (
          <div>
            <StickyComponent
              domainConfig={props.domainConfig}
              stickyState={stickyHeader}
              menuItemsObject={menuItemsObject}
              headerProps={headerProps}
              page={page}
            />

            <BigHeaderComponent
              domainConfig={props.domainConfig}
              stickyState={stickyHeader}
              menuItemsObject={menuItemsObject}
              headerProps={headerProps}
              page={page}
            />
          </div>
        ) : (
          <div styleName="container" className="header-container">
            <HeaderTopContent {...headerProps} />
          </div>
        )}
      </React.Fragment>
    );
  };

  const storyPageHeaderComponent = () => {
    return (
      <div>
        {isDesktop ? (
          <div>
            <div className="sticky-header" styleName="sticky-header">
              <SecondaryStoryHeaderTopContent {...headerProps} isVideoStory={isVideoStory} />
            </div>
            <div styleName="container" className="header-container">
              <StoryHeaderTopContent {...headerProps} />
            </div>
          </div>
        ) : (
          <div styleName="container" className="header-container">
            <HeaderTopContent {...headerProps} />
          </div>
        )}
      </div>
    );
  };

  const genericComponent = () => {
    return <DefaultHeader {...headerProps} publisherAttributes={publisherAttributes} stickyHeader={stickyHeader} />;
  };

  const RenderComponents = React.memo(function MyComponent(props) {
    switch (props.pageType) {
      case "home-page":
        return homeSectionHeaderComponent("home");
      case "section-page":
        return homeSectionHeaderComponent("section");
      case "collection-page":
        return homeSectionHeaderComponent("section");
      case "story-page":
        return storyPageHeaderComponent();
      default:
        return genericComponent();
    }
  });
  return (
    <React.Fragment>
      <RenderComponents pageType={props.pageType} />
    </React.Fragment>
  );
};

HeaderBase.propTypes = {
  pageType: string,
  stickyHeader: bool,
  domainConfig: object,
  domainSlug: string,
  prothomaloMenuItems: array,
  protichintaMenuItems: array,
  bigganChintaMenuItems: array,
  bondhushavaMenuItems: array,
  trustMenuItems: array,
  kishoraloMenuItems: array,
  nagorikMenuItems: array,
  isVideoStory: bool,
  publisherAttributes: object,
  isDesktop: bool
};

BigHeaderComponent.propTypes = {
  stickyState: bool,
  domainConfig: object,
  page: string,
  headerProps: object,
  menuItemsObject: object
};

StickyComponent.propTypes = {
  stickyState: bool,
  domainConfig: object,
  page: string,
  headerProps: object,
  menuItemsObject: object
};

function mapStateToProps(state) {
  return {
    menu: get(state, ["qt", "data", "navigationMenu"], []),
    pageType: get(state, ["qt", "pageType"], ""),
    domainSlug: get(state, ["qt", "domainSlug"], ""),
    prothomaloMenuItems: get(state, ["qt", "data", "navigationMenu", "prothomaloMenuItems"], []),
    protichintaMenuItems: get(state, ["qt", "data", "navigationMenu", "protichintaMenuItems"], []),
    bigganChintaMenuItems: get(state, ["qt", "data", "navigationMenu", "bigganChintaMenuItems"], []),
    bondhushavaMenuItems: get(state, ["qt", "data", "navigationMenu", "bondhushavaMenuItems"], []),
    trustMenuItems: get(state, ["qt", "data", "navigationMenu", "trustMenuItems"], []),
    kishoraloMenuItems: get(state, ["qt", "data", "navigationMenu", "kishoraloMenuItems"], []),
    nagorikMenuItems: get(state, ["qt", "data", "navigationMenu", "nagorikMenuItems"], []),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
}

export const Header = connect(mapStateToProps, () => ({}))(HeaderBase);
